import { DownOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd';

import type { BulkOperationOption } from '../../types';

import {
  DEFAULT_BUTTON_TEXTS,
  DEFAULT_DROPDOWN_TEXT,
  DROPDOWN_TRIGGER
} from './constants';

type Props = {
  bulkOperationOptions: BulkOperationOption[];
};

export const RowSelectionMenuButton = ({ bulkOperationOptions }: Props) => {
  const dropdownMenu = {
    items: bulkOperationOptions.map(item => ({
      key: item.type,
      label: item.buttonText || DEFAULT_BUTTON_TEXTS[item.type]
    })),
    onClick: ({ key }: { key: string }) => {
      const foundOption = bulkOperationOptions.find(
        option => option.type === key
      );

      foundOption?.onClick();
    }
  };

  return (
    <Dropdown menu={dropdownMenu} trigger={DROPDOWN_TRIGGER}>
      <Button icon={<DownOutlined />} iconPosition='end'>
        {DEFAULT_DROPDOWN_TEXT}
      </Button>
    </Dropdown>
  );
};
